import { ProgrammeMember } from './programmeMember';
import { ProgrammeCourse } from './programmeCourse';

export class Programme {
    id: number;
    name: string;
    owner_id: number;
    members: ProgrammeMember[];
    courses: ProgrammeCourse[];
    status:string;
    start_date;
    close_date;
    constructor(programme?) {
        if (programme) {
            this.id = programme.id;
            this.name = programme.name;
            this.owner_id = programme.owner_id;
            this.members = programme.members;
            this.courses = programme.courses;
            this.status = programme.status;
            this.start_date = programme.start_date;
            this.close_date = programme.close_date;
        }
    }
}
